import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import PlTitle from "../../elements/PlTitle";


import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";

import XDateFee from "../kids/XDateFee";
import XTime from "../kids/XTime";

import FormatTime from "../../helpers/FormatTime";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import AppContext from "../../AppContext";
import InputCombo from "../../helpers/InputCombo";



function Hour(props)
{

    const tabRef = useRef(0);
    const tab2Ref = useRef(0);
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        p_imie_nazwisko: props.mainView.readFilter('p_imie_nazwisko',''),    
      
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,       
        archiwalny: '0',
        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);




    var dt = new Date();
    const [showDay, setShowDay] = useState({
        from: dt.getDate() - 3,
        to: dt.getDate() + 3,
    });
    const [strToDay, setStrToDate] = useState( dt.toISOString().split`T`[0]  ); 


    const showAllDays = () => {

        if(showDay.from == -1)
            {
                var dt = new Date();
                setShowDay({
                    from: dt.getDate() - 3,
                    to: dt.getDate() + 3,
                });

                props.mainView.changeMenuStatus(1);
                return;
            }


            props.mainView.changeMenuStatus(0);
        setShowDay({
            from: -1,
            to: 32
        });

    }

 



    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
 
         setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
         
         if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

         props.mainView.writeFilter(filedName, val);
     }



     const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {

        props.mainView.writeFilter('p_imie_nazwisko', '');
        
        setFilterParam({
            p_imie_nazwisko: '', 
           
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,         
            limit: 50,
            page: 1,
            show:true, 
        });
        setTab(null);


    }

    const filterApprove = () => {   
        setTab(null)     
    }




    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_emps,hour', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


 
    const onChangeXTime = (hm, param1, param2, param3, param4) =>  {

        console.log("XTime ", hm, param1, param2, param3, param4);


        props.mainView.setProgress(-2);

       
        var req = {
            px_group_id: param1,
            hm: hm,
            dzien: param2
        };


        fetch( Config.url + '/rest_v1_emps,hour_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane" , "ok" , null );
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });


    }




    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
        }





        return (
            <div className="view_content">
                   


                      {
                            filterParam.show == false  &&
                            <div className="  goright link_color" onClick={filterView}>
                                pokaż filtry
                            </div>
                        }


                      {
                            filterParam.show == true  &&
                            <div className="table_filter">
               
                         

                        <div className="filter_controll">   
                            <label>Archiwalny: </label>                             
                            <InputCombo  items={ [ {v: '_x_', title:'- - - '}, {v: '0', title:'Nie'}, {v: '1', title:'Tak'},   ] }  userData={props.userData}  mainView={props.mainView}  value={filterParam.archiwalny}   valChange={valChangeListener} goNext={goNextNew} name="archiwalny" placeholder={": "}  noempty="1"   />
                        </div> 
                            
                           <div className="filter_controll">   
                                <label>Pracownik: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.p_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="p_imie_nazwisko" placeholder={"Pracownik: "}   />
                            </div>  

                         

                            <div className="filter_controll">   
                                <label>Rok: </label>                             
                                <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                            </div> 

                            <div className="filter_controll">   
                                <label>Miesiąc: </label>                             
                                <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                            </div> 


                            <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

                          </div>
                        }     

                    


                <div className="table_widget">    
                    <span className="link_color" onClick={showAllDays}>Zmień widok</span>

                    &nbsp; &nbsp;

                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Nadgodziny pracowników" />   
                    <Csv tabRef={tab2Ref} />                  
                    <Print tabRef={tab2Ref} />

                </div>

                <div className=" bg_center">

 
                <div ref={tabRef} className="gohide">
                         <h3>Godziny pracowników {filterParam.rok + "-" + filterParam.miesiac }</h3>   

                         <table className="table" ref={tab2Ref} >
                                                    <thead>
                                                        <tr className="header">
                                                            <td>LP</td>                                                 
                                                            <td>Pracownik</td>  
                                                       

                                                            {
                                                                tab.map( (row, ix) => {

                                                                    if(ix > 0) return null;

                                                                    return (
                                                                        row.dni.map( (dd, ir) => {
                                                                        
                                                                           

                                                                            return (
                                                                                <td>{ir+1} </td>
                                                                            )
                                                                        } )
                                                                    )
                                                                

                                                                } )
                                                            }

                                                        
                                                            <td>Razem</td>
                                                         

                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                            {
                                                                                                              

                                                                tab.map( (row, ix) => {
                                                                    
                                                                    var iloscRoz   = 0;
                                                                    var razemKwota = 0;
                                                             
                                                            

                                                                    return (
                                                                        <tr className="row">
                                                                            <td className="gocenter" >{ix+1}</td>                                                  
                                                                            <td >{row.nazwisko + " " + row.imie}</td>  
                                                                      
                                                                            {
                                                                                row.dni.map( (dd, ir) => {

                                                                
                                                                           

                                                                                    var clsTD = " e_square_center ";
                                                                                    var clsSquare = "e_ob_def";


                                                                                    if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                                    if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                                    if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                                    if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                                 

                                                                              
                                                                                    iloscRoz = parseFloat( iloscRoz + dd.minuty ) ; 

                                                                                    if(dd.minuty > 0) clsTD = clsTD + " txt_show ";
                                                                           

                                                                                    var info = row.imie + " " + row.nazwisko + "<br/>" + dd.dzien+ "<br/>" + dd.czas.g+":" + dd.czas.m;

                                                                               
                                                                                    return <td className={clsTD + " txtcloud link_normal "} title={dd.naliczona_kwota}>
                                                                                                                                                                        
                                                                                               {dd.czas.g + ":" +  dd.czas.m}                                                                                    
                                                                               
                                                                                    </td>
                                                                                
        
                                                                                } )

                                                                            
                                                                            
                                                                            } 
                                                                            <td  className="goright gobold"> <FormatTime minute={iloscRoz} /> </td>   
                                                                 

                                                                        </tr>
                                                                    )


                                                                  

                                                                 

                                                                } )
                                                            }


                                                            
        

                                                    </tbody>

                            </table>
                </div>



                   <div className="scorll_x">
                            <table className="table" >
                                                    <thead>
                                                        <tr className="header">
                                                            <td className="td_left">LP</td>                                                 
                                                            <td>Pracownik</td>  
                                                       

                                                            {
                                                                tab.map( (row, ix) => {

                                                                    if(ix > 0) return null;

                                                                    return (
                                                                        row.dni.map( (dd, ir) => {
                                                                        
                                                                            if(ir < showDay.from) return <td></td>

                                                                            if(ir > showDay.to)   return <td></td>

                                                                            return (
                                                                                <td>{ir+1} </td>
                                                                            )
                                                                        } )
                                                                    )
                                                                

                                                                } )
                                                            }

                                                        
                                                            <td className="td_right">Razem</td>
                                                         

                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                            {
                                                                                                              

                                                                tab.map( (row, ix) => {
                                                                    
                                                                    var iloscRoz   = 0;
                                                                    var razemKwota = 0;
                                                             
                                                                    var rowStyle = " row ";
                                                                    if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                    return (
                                                                        <tr className={rowStyle}>
                                                                            <td className="gocenter" >{ix+1}</td>                                                  
                                                                            <td >{row.nazwisko + " " + row.imie}</td>  
                                                                      
                                                                            {
                                                                                row.dni.map( (dd, ir) => {

                                                                                    iloscRoz = parseFloat( iloscRoz + dd.minuty ) ; 

                                                                                    
                                                                                    if(ir < showDay.from) return <td></td>
                                                                                    if(ir > showDay.to)   return <td></td>

                                                                                    var clsTD = " e_square_center ";
                                                                                    var clsSquare = "e_ob_def";


                                                                                    if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                                    if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                                    if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                                    if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                              

                                                                              
                                                                              

                                                                                    if(dd.minuty > 0) clsTD = clsTD + " txt_show ";
                                                                           

                                                                                    var info = row.imie + " " + row.nazwisko + "<br/>" + dd.dzien+ "<br/>" + dd.czas.g+":" + dd.czas.m;

                                                                               
                                                                                    return <td className={clsTD + " txtcloud link_normal "} title={dd.naliczona_kwota}>
                                                                                                                                                                        

                                                                                        <XTime title={ row.imie + " " + row.nazwisko + " - " + dd.dzien } hour={dd.czas.g} minute={dd.czas.m}  onChange={onChangeXTime} param1={row.id} param2={dd.dzien}  param3='' param4='' />
                                                                                     
                                                                                        <div className="info_content">
                                                                                             <span className="info_cloud shadowx" dangerouslySetInnerHTML={{__html: info }}   >                                                                                                  
                                                                                             </span>
                                                                                        </div>                                                                                      
                                                                               
                                                                                    </td>
                                                                                
        
                                                                                } )

                                                                            
                                                                            
                                                                            } 
                                                                            <td  className="goright gobold"> <FormatTime minute={iloscRoz} /> </td>   
                                                                 

                                                                        </tr>
                                                                    )


                                                                  

                                                                 

                                                                } )
                                                            }


                                                            
        

                                                    </tbody>

                            </table>
                    </div>
                </div>



            </div>
        )
}

export default Hour;